<template>
	<BaseMultiSelect
		:searchable="true"
		placeholder="Alle medarbejdere"
		:options="options"
		@option:selected="($event) => $emit('change', $event)"
	></BaseMultiSelect>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
import BaseMultiSelect from "@elements/select/BaseSingleSelect.vue";
import Service from "@services/UserService";

const props = defineProps({
	isAll: {
		type: Boolean,
		default: true,
		required: false,
	},
	department: String,
	userDeps: {
		type: Array,
		default: [],
		required: false,
	},
});

const options = ref([]);

watch(
	() => props.department,
	(newVal, oldVal) => {
		if (newVal !== oldVal && oldVal !== undefined) {
			options.value = [];
			populateOptions();
		}
	},
);

onMounted(async () => {
	populateOptions();
});

const populateOptions = async () => {
	const service = new Service();
	if (props.isAll) {
		options.value.push({ label: `Alle medarbejdere`, option: "", dep_ids: [] });
	}
	let employees = await service.getAll();
	if (props.department) {
		employees = employees.filter((employee) =>
			employee.department_ids.includes(props.department.option),
		);
	}
	if (props.userDeps.length > 0) {
		employees = employees.filter((employee) =>
			props.userDeps.some((depId) =>
				employee.department_ids.includes(depId.toString()),
			),
		);
	}
	employees = employees.filter(
		(employee) => employee.user_status === "active",
	);
	employees.forEach((employee) => {
		const option = {
			label: `${employee?.fname} ${employee?.lname}`,
			option: employee.user_id,
			dep_ids: employee.department_ids.split(",").map(Number) || [],
		};
		options.value.push(option);
	});
};
defineExpose({ options });
</script>
